import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/$locale/checklist/$planId')({
  component: () => null, // lazy-loaded
});
